import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { tradeOrderTypeAtom } from '@root/features/trade/trading'

import { TradingControlsQuote } from '../trading-controls-quote/trading-controls-quote'

import type { SellControlsModel } from '../../../atoms/common'
import type { Pair } from '@root/entities/pair'

type Props = {
  pair: Pair.PairMinimal
  model: SellControlsModel
}

export const TradingControlsSellQuote: React.FC<Props> = ({ model, pair }) => {
  const [amountCurrency] = useAtom(model.inputModel.amountAtom)
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)
  const [limitReceiveAmount] = useAtom(model.limitModel.receiveAtom)
  const [quoteState_] = useAtom(model.quoteModel.quoteStateAtom)

  const quoteState = useMemo(() => {
    if (tradeOrderType === 'limit') {
      return AsyncStateN.success({
        inputAmount: amountCurrency,
        outputAmount: limitReceiveAmount,
      })
    }
    return quoteState_
  }, [amountCurrency, limitReceiveAmount, quoteState_, tradeOrderType])

  if (amountCurrency.isZero()) {
    return undefined
  }

  return (
    <QuoteStyled quoteState={quoteState} swapDirection="sell" pair={pair} />
  )
}

const QuoteStyled = styled(TradingControlsQuote)`
  place-content: end;
  padding-bottom: 10px;
  min-height: 24px;
  margin-inline: 10px;
`
